import { http } from "../http/Http";
import { ObjectTable, ServiceResponse, GetByFiltersArguments } from "../models";

export class ObjectTableService {

    getObjectTables = async (): Promise<ServiceResponse<ObjectTable[]>> => {
        const { data } = await http.get<ServiceResponse<ObjectTable[]>>("ObjectTable/GetAll");
        return data;
    };

    getObjectTableByCode = async (code: string): Promise<ObjectTable> => {
        const { data } = await http.get<ObjectTable>(("ObjectTable/GetByCode/" + code));
        return data;
    };

    getObjectTableExternalIdByName = async (objectTableName: string): Promise<string> => {
        const { data } = await http.get<string>(("ObjectTable/GetObjectTableExternalIdByName/" + objectTableName));
        return data;
    };
}